import React from 'react';
import { EvolutionInstance } from '../../types/admin';
import './AdminStyles.css';

interface EvolutionInstancesListProps {
  instances: EvolutionInstance[];
  loading: boolean;
  testingId?: number | null;
  // URL global do webhook (a mesma para todas as instâncias).
  webhookUrl?: string;
  onEdit: (instance: EvolutionInstance) => void;
  onDelete: (id: number) => void;
  onToggle: (id: number) => void;
  onTest: (id: number) => void;
}

// Lista dedicada das instâncias Evolution.
export const EvolutionInstancesList: React.FC<EvolutionInstancesListProps> = ({
  instances,
  loading,
  testingId,
  webhookUrl,
  onEdit,
  onDelete,
  onToggle,
  onTest,
}) => {
  const getCreatedAt = (instance: EvolutionInstance) => {
    const value = instance.createdAt ?? instance.created_at;
    return value ? new Date(value).toLocaleDateString('pt-BR') : '—';
  };

  // O webhook é global (mesma URL para todas as instâncias) — copia sempre a mesma URL.
  const copyWebhookUrl = async () => {
    if (!webhookUrl) {
      window.alert('Webhook indisponível.');
      return;
    }
    try {
      await navigator.clipboard.writeText(webhookUrl);
      window.alert('URL do webhook copiada:\n\n' + webhookUrl);
    } catch {
      // Fallback: mostra a URL para cópia manual caso a clipboard API não esteja disponível.
      window.prompt('Copie a URL do webhook:', webhookUrl);
    }
  };

  if (loading) {
    return <div className="accounts-loading">Carregando instâncias...</div>;
  }

  if (instances.length === 0) {
    return (
      <div className="accounts-empty">
        <p>Nenhuma instância Evolution configurada</p>
      </div>
    );
  }

  return (
    <div className="accounts-table-container">
      <table className="accounts-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Instância</th>
            <th>Número</th>
            <th>V8</th>
            <th>URL Base</th>
            <th>Webhook</th>
            <th>Status</th>
            <th>Criado</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          {instances.map(instance => (
            <tr key={instance.id} className={!instance.is_active ? 'account-inactive' : ''}>
              <td>{instance.id}</td>
              <td className="account-title">{instance.instance_name}</td>
              <td className="account-identifier">{instance.number}</td>
              <td className="account-identifier">{instance.V8Auth?.login || (instance.v8_id ? `#${instance.v8_id}` : '—')}</td>
              <td className="account-identifier">{instance.base_url}</td>
              <td>
                <button
                  className="btn-edit"
                  onClick={() => copyWebhookUrl()}
                  title="Copiar URL do webhook global"
                >
                  📋 Copiar
                </button>
              </td>
              <td>
                <button
                  className={`status-badge ${instance.is_active ? 'active' : 'inactive'}`}
                  onClick={() => onToggle(instance.id)}
                >
                  {instance.is_active ? 'Ativo' : 'Inativo'}
                </button>
              </td>
              <td className="account-date">{getCreatedAt(instance)}</td>
              <td className="account-actions">
                <button
                  className="btn-edit"
                  onClick={() => onTest(instance.id)}
                  disabled={testingId === instance.id}
                  title="Testar (envia mensagem do número para ele mesmo)"
                >
                  {testingId === instance.id ? '⏳' : '🧪'}
                </button>
                <button className="btn-edit" onClick={() => onEdit(instance)} title="Editar">
                  ✏️
                </button>
                <button
                  className="btn-delete"
                  onClick={() => {
                    if (window.confirm(`Deletar instância ${instance.instance_name}?`)) {
                      onDelete(instance.id);
                    }
                  }}
                  title="Deletar"
                >
                  🗑️
                </button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
